import { gql } from '@apollo/client';

/* ── settings ───────────────────────────────────────────────── */

/** NSE MF platform registration for the signed-in account (UCC, FATCA, bank). */
export const MF_REGISTRATION = gql`
  query MfRegistration {
    mfRegistration {
      id
      ucc
      uccStatus
      fullName
      panNumber
      taxStatus
      fatcaStatus
      clientAuthStatus
      bankValidationStatus
      platform
      createdAt
    }
  }
`;
